<div class="spinner" *ngIf="loading">Loading data</div>

<table class="table table-compact table-striped" *ngIf="!loading && rows.length > 0">
  <thead>
  <tr>
    <th>Pos.</th>
    <th>Bezeichnung</th>
    <th class="right">Angebot Menge</th>
    <th class="right">Angebot Preis</th>
    <th class="right">Angebot Summe</th>
    <th class="right">EK Menge</th>
    <th class="right">EK Preis</th>
    <th class="right">EK Summe</th>
    <th class="right">VK Menge</th>
    <th class="right">VK Preis</th>
    <th class="right">VK Summe</th>
    <th class="right">Marge</th>
  </tr>
  </thead>
  <tbody>
  <tr *ngFor="let row of rows">
    <td>{{ row.position }}<span *ngIf="row.part > 0">.{{ row.part }}</span></td>
    <td class="left">{{ row.name }}<br><small>{{ row.technical_drawing }}</small></td>
    <td class="right">{{ row.offer_qty }}</td>
    <td class="right">{{ row.offer_unit_price | currency: 'EUR':'code':'1.2-4':'de' }}</td>
    <td class="right">{{ row.offer_total | currency: 'EUR':'code':'1.2-2':'de' }}</td>
    <td class="right">{{ row.ek_qty }}</td>
    <td class="right">{{ row.ek_unit_price | currency: 'EUR':'code':'1.2-4':'de' }}</td>
    <td class="right">{{ row.ek_total | currency: 'EUR':'code':'1.2-2':'de' }}</td>
    <td class="right">{{ row.vk_qty }}</td>
    <td class="right">{{ row.vk_unit_price | currency: 'EUR':'code':'1.2-4':'de' }}</td>
    <td class="right">{{ row.vk_total | currency: 'EUR':'code':'1.2-2':'de' }}</td>
    <td class="right"><b>{{ row.margin_total | currency: 'EUR':'code':'1.2-2':'de' }}</b></td>
  </tr>
  </tbody>
  <tfoot>
  <tr>
    <td colspan="4"><b>Gesamtsumme</b></td>
    <td class="right"><b>{{ sumOfferTotal | currency: 'EUR':'code':'1.2-2':'de' }}</b></td>
    <td colspan="2"></td>
    <td class="right"><b>{{ sumEkTotal | currency: 'EUR':'code':'1.2-2':'de' }}</b></td>
    <td colspan="2"></td>
    <td class="right"><b>{{ sumVkTotal | currency: 'EUR':'code':'1.2-2':'de' }}</b></td>
    <td class="right"><b>{{ sumMarginTotal | currency: 'EUR':'code':'1.2-2':'de' }}</b></td>
  </tr>
  </tfoot>
</table>

<p *ngIf="!loading && rows.length === 0">Keine Controlling-Daten für diesen Job gefunden.</p>
